import { useState, useCallback } from "react";

const useMontarLogica = () => {
  const [importarPlanilha, setImportarPlanilha] = useState(false);
  const [incluirRegistro, setIncluirRegistro] = useState(false);
  const [mostrarLista, setMostrarLista] = useState(true);
  const [mostrarTelaInicial, setMostrarTelaInicial] = useState(true);

  // Usando useCallback para garantir que a função não recrie a cada render
  const montarLogica = useCallback((modo) => {
    switch (modo) {
      case 1: // inicialização
        setImportarPlanilha(false);
        setIncluirRegistro(false);
        setMostrarLista(true);
        setMostrarTelaInicial(true);
        break;

      case 2: // mostrar tela de Importação da Planilha
        setImportarPlanilha(true);
        setIncluirRegistro(false);
        setMostrarLista(false);
        setMostrarTelaInicial(false);
        break;

      case 3: // mostrar tela de Inclusão de Novo Registro
        setImportarPlanilha(false);
        setIncluirRegistro(true);
        setMostrarLista(false);
        setMostrarTelaInicial(false);
        break;

      case 4: // retorno à tela inicial sem lista
        setImportarPlanilha(false);
        setIncluirRegistro(false);
        setMostrarLista(false);
        setMostrarTelaInicial(true);
        break;

      default:
        console.warn("Modo desconhecido:", modo);
    }
  }, []);

  return {
    montarLogica,
    setMostrarLista,
    importarPlanilha,
    incluirRegistro,
    mostrarLista,
    mostrarTelaInicial,
  };
};

export default useMontarLogica;
